module.exports = __webpack_public_path__ + "img/third_wave_top.2d719a90.svg";